// extracted by mini-css-extract-plugin
export default {"container":"InfoSection_container__SbRYc","inner":"InfoSection_inner__H8LGo","title":"InfoSection_title__RlOkY","list":"InfoSection_list__tJnTH"};